var _circle, _circle2, _circle3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaybtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6325,
    cy: 23.6322,
    r: 22.8678,
    fill: "url(#paint0_linear_145_102)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6325,
    cy: 23.6322,
    r: 22.8678,
    fill: "url(#paint1_angular_145_102)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23.6325,
    cy: 23.6322,
    r: 22.8678,
    fill: "url(#paint2_linear_145_102)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6325,
    cy: 23.6322,
    r: 22.8678,
    stroke: "#757575"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_145_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3037 33.8558V12.9221L34.3427 23.6324L17.3037 33.8558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3037 33.8558V12.9221L34.3427 23.6324L17.3037 33.8558Z",
    fill: "url(#paint3_radial_145_102)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3037 33.8558V12.9221L34.3427 23.6324L17.3037 33.8558Z",
    fill: "url(#paint4_linear_145_102)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3037 33.8558V12.9221L34.3427 23.6324L17.3037 33.8558Z",
    stroke: "url(#paint5_linear_145_102)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_145_102",
    x: 16.0537,
    y: 10.4697,
    width: 23.7667,
    height: 27.8276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_145_102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_102",
    x1: 0.264648,
    y1: 0.264404,
    x2: 47.0003,
    y2: 0.264404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C40E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A44B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_145_102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124 -30) rotate(142.505) scale(126.502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471354,
    stopColor: "white",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_145_102",
    x1: 24,
    y1: -6,
    x2: 31,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDFDFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_145_102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5 23) rotate(133.091) scale(21.225 17.2762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_145_102",
    x1: 23.5,
    y1: 10.5,
    x2: 29,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_145_102",
    x1: 26,
    y1: 34,
    x2: 17,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#959595"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybtn);
export default __webpack_public_path__ + "static/media/playbtn.e3dc4932ac5130bfdf3f5bb20d08f964.svg";
export { ForwardRef as ReactComponent };